import en from './en';
import cs from './cs';

export const availableLanguages = ['en', 'cs'] as const;
export type AvailableLanguage = (typeof availableLanguages)[number];

export const dictionaries = {
  en,
  cs
} as const;
